import { COUNTRY_DOMAIN_SUFFIXES, SUPPORTED_COUNTRIES, type AppCountry } from '../models/AppCountry.ts';

const DEFAULT_COUNTRY: AppCountry = 'fr';

const SUFFIX_COUNTRY_MAP: Record<string, AppCountry> = Object.entries(COUNTRY_DOMAIN_SUFFIXES)
    .flatMap(([country, suffixes]) => suffixes.map((suffix) => [suffix, country as AppCountry]))
    .reduce((acc, [suffix, country]) => {
        acc[suffix] = country as AppCountry;
        return acc;
    }, {} as Record<string, AppCountry>);

export const getCurrentCountry = (hostname: string): AppCountry => {
    const lowerHost = hostname.toLowerCase();

    for (const suffix in SUFFIX_COUNTRY_MAP) {
        if (lowerHost.endsWith(`.${suffix}`)) {
            return SUFFIX_COUNTRY_MAP[suffix];
        }
    }

    return DEFAULT_COUNTRY;
};

export const isSupportedCountry = (country: AppCountry) => {
    return SUPPORTED_COUNTRIES.includes(country);
};
